import { render, staticRenderFns } from "./MemberTargetDetail.vue?vue&type=template&id=1501d4cc&"
import script from "./MemberTargetDetail.vue?vue&type=script&lang=ts&"
export * from "./MemberTargetDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports